import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Grid from "@mui/material/Grid";
import {
  loginUser,
  userSelector,
  clearState,
} from "../../components/redux/modules/globalSlice";
import "./login.css";
import { Paper, Button, TextField, CircularProgress } from "@mui/material";
import { useHistory } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import Logo from "../../images/logo2.png";
import { useFormik } from "formik";
import * as yup from "yup";
import { get } from "lodash";

export default function Login() {
  const history = useHistory();

  const dispatch = useDispatch();
  const { isFetching, isSuccess, isError } =
    useSelector(userSelector);

  useEffect(() => {
    return () => {
      dispatch(clearState());
    };
  }, []);

  useEffect(() => {
    if (isError) {
      setTimeout(() => {
        dispatch(clearState());
      }, 3000);
    }

    if (isSuccess) {
      dispatch(clearState());

      // if (localStorage.length != 0) {
      history.push("/Dashboard/Dashboard");
      // }
    }
  }, [isError, isSuccess]);

  const validationSchema = yup.object({
    username: yup
      .string("Enter your username")
      .required("Username is required"),
    password: yup
      .string("Enter your password")
      .required("Password is required"),
  });

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      
      dispatch(loginUser(values));
    },
  });

  const isErr = (fieldName) => {
    return (
      get(formik.touched, fieldName, false) &&
      Boolean(get(formik.errors, fieldName, false))
    );
  };


  return (
    <Grid container md={12}>
      <Grid item xs={12}>
        <form
          onSubmit={formik.handleSubmit}
          className="container"
          method="POST"
        >
          <div style={{display:'flex', justifyContent:"end", alignItems:"center", height:"100vh"}}>
            <Paper
              elevation={3}
              sx={{
                // marginTop: 10,
                marginRight: { sm: 35 },
                width: {
                  xs: "100%",
                  sm: 500,
                },
                borderRadius: 3,
              }}
            >
              <div>
                <div>
                  <div style={{ justifyContent: "center", display: "flex" }}>
                    <img src={Logo} alt="" className="size" id="logoLogin" />
                  </div>
                  {isError ? (
                    <Stack sx={{ width: "100%" }} spacing={2}>
                      <Alert severity="error">
                        Username or Password is incorrect.
                      </Alert>
                    </Stack>
                  ) : null}
                  <Paper
                    elevation={2}
                    style={{ padding: 5, margin: 10, marginTop: 25 }}
                  >
                    <div
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span
                        className="material-icons-outlined"
                        style={{ color: "gray", margin: 10 }}
                      >
                        email
                      </span>
                      <TextField
                        id="username"
                        placeholder="Username"
                        variant="standard"
                        size="medium"
                        InputProps={{
                          disableUnderline: true,
                        }}
                        style={{
                          flexGrow: 1,
                        }}
                        name="username"
                        value={formik.values.username}
                        onChange={formik.handleChange}
                        error={isErr("username")}
                        // helperText={getErrorMessage("username")}
                      />
                    </div>
                  </Paper>
                  <Paper
                    elevation={2}
                    style={{ padding: 5, margin: 10, marginTop: 25 }}
                  >
                    <div
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span
                        className="material-icons-outlined"
                        style={{ color: "gray", margin: 10 }}
                      >
                        lock
                      </span>
                      <TextField
                        type="password"
                        variant="standard"
                        id="password"
                        placeholder="Password"
                        size="medium"
                        InputProps={{
                          disableUnderline: true,
                        }}
                        style={{
                          flexGrow: 1,
                        }}
                        name="password"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        error={isErr("password")}
                        // helperText={getErrorMessage("password")}
                      />
                    </div>
                  </Paper>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginTop: 30,
                      marginBottom: 40,
                    }}
                  >
                    {/* <FormControlLabel control={<Checkbox />} label="Remember Me" />
                <span style={{ alignSelf: "center" }}>Forgot Password ?</span> */}
                  </div>

                  <div
                    style={{
                      justifyContent: "center",
                      display: "flex",
                    }}
                  >
                    <Button
                      size="large"
                      variant="contained"
                      type="submit"
                      disableRipple
                      style={{
                        backgroundColor: "#38A59D",
                        color: "white",
                        width: 100,
                        marginBottom: 5,
                      }}
                      // onClick={login}
                    >
                      {isFetching ? (
                        <CircularProgress
                          sx={{
                            color: "#FFFFFF",
                          }}
                          size={24}
                        />
                      ) : (
                        "Sign in"
                      )}
                    </Button>
                  </div>
                </div>
              </div>
            </Paper>
          </div>
        </form>
      </Grid>
    </Grid>
  );
}
